import React from 'react';

const Footer = props => {
  return(
    <div className="no-print container-fluid container-fixed-lg footer bg-app-white">
      <div className="copyright sm-text-center">
        <p className="small no-margin pull-left sm-pull-reset">
          <span className="hint-text">Copyright © 2019 </span>
          <span className="font-montserrat">Immersed Games. </span>
          <span className="hint-text">All rights reserved.</span>
          <span className="sm-block"><a href="http://immersedgames.com/termsofservice/" className="m-l-10 m-r-10">Terms of use</a> | <a href="http://immersedgames.com/privacypolicy/" className="m-l-10">Privacy Policy</a></span>
        </p>
        <div className="clearfix"></div>
      </div>
    </div>
  );
}

export default Footer;
